import { Link } from 'react-router-dom';
import CtaLink from '@/pages/home/components/CtaLink';

export default function AboutHero() {
  return (
    <section className="relative overflow-hidden pt-28 md:pt-40 pb-16 md:pb-24">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -left-24 w-[480px] h-[480px] rounded-full bg-primary-500/10 blur-[120px] animate-glow-pulse" />
        <div className="absolute top-1/3 -right-24 w-[420px] h-[420px] rounded-full bg-background-300/50 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — copy */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold tracking-wide text-primary-400">
              ABOUT JOSH
            </span>

            <h1 className="mt-6 font-heading font-bold text-4xl md:text-5xl lg:text-[3.2rem] leading-[1.1] text-foreground-950">
              Helping Home Service Businesses Build{' '}
              <span className="text-primary-400">
                Predictable, Measurable Growth.
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              Over the last decade, Josh Hastings has helped established
              local-service and home-service businesses create predictable
              growth and scale past $1,000,000 through smarter marketing
              systems, lead generation, follow-up, and business strategy.
            </p>

            <p className="mt-4 text-base text-foreground-600 leading-relaxed max-w-xl">
              His primary focus is helping{' '}
              <strong className="text-foreground-950 font-semibold">
                Roofers, HVAC companies, and Hardscape/Landscape businesses
              </strong>{' '}
              doing $300,000 or more annually build smarter marketing systems
              that generate more leads, improve follow-up, increase conversions,
              and create more predictable growth.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <CtaLink>Apply to Work With Me</CtaLink>
              <Link
                to="/results"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 font-label font-semibold text-sm border border-primary-500/40 text-foreground-950 hover:border-primary-500 hover:bg-primary-500/10 transition-all duration-300 hover:-translate-y-0.5">
                See Client Results
              </Link>
            </div>
          </div>

          {/* Right — portrait */}
          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/20 via-transparent to-background-300/40 blur-2xl" />
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <div className="relative w-full aspect-[4/5]">
                <img
                  src="/assets/images/Josh-Hastings-Full-Length.jpg"
                  alt="Josh Hastings, marketing strategist and business growth advisor"
                  title="Josh Hastings — Marketing Strategist & Business Growth Advisor"
                  className="absolute opacity-70 inset-0 w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute top-5 left-5 inline-flex items-center gap-2 rounded-full bg-background-50/80 backdrop-blur-md border border-white/10 px-4 py-2">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400"></span>
                <span className="text-xs font-label font-semibold text-foreground-950 whitespace-nowrap">
                  Home Service Growth Strategist
                </span>
              </div>

              <div className="absolute bottom-20 right-5 inline-flex items-center gap-2 rounded-full bg-background-50/80 backdrop-blur-md border border-white/10 px-4 py-2">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
                <span className="text-xs font-label font-semibold text-foreground-950 whitespace-nowrap">
                  Marketing Systems & Lead Generation
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
